<template>
  <div class="main">
    <div class="b-nav">
      <img src="../assets/imgs/spec/icon_home.png" alt="">
      <div class="location">您当前所在的位置:</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>党的建设</el-breadcrumb-item>
<!--        <el-breadcrumb-item>{{childContent}}</el-breadcrumb-item>-->
      </el-breadcrumb>
    </div>
    <div class="content">
      <column-nav :fl-details="contentDetail" :now-column="nowColumn" @b-content="getChildContent" />
      <article-list :article-list="articleList" :list-title="contentDetail[0]" @getPage="getNewData"/>
    </div>
  </div>
</template>

<script>
  import ColumnNav from "../components/common/ColumnNav";
  import ArticleList from "../components/common/ArticleList";
  import {pbInfo, peList, wdList} from '../api/index'
  export default {
    name: "PartyBuilding",
    components: {
      ColumnNav,
      ArticleList
    },
    data() {
      return {
        contentDetail: ['党的建设','学习宣传贯彻党的二十大精神', '学习贯彻省第十三次党代会、市第十一次党代会', '党史学习教育', '学习贯彻习近平新时代中国特色社会主义思想主题教育', '深入开展党纪学习教育','深入贯彻中央八项规定精神学习教育', '深入学习贯彻党的二十届四中全会精神'],
        nowColumn: 1,
        articleList: {}
      }
    },
    methods: {
      getChildContent(data) {
        this.childContent = this.contentDetail[data-1]
        this.nowColumn = data - 1
        if (data - 1 === 0) {
          this.getData()
        } else if (data-1 === 3) {
          peList(1).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        }else if (data - 1 === 1) {
          let query = {
            cid: 5
          }
          wdList(1,query).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        } else if (data-1 === 4) {
          let query = {
            cid: 6
          }
          wdList(1,query).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        }  else if (data-1 === 5) {
          let query = {
            cid: 7
          }
          wdList(1,query).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        } else if (data-1 === 6) {
          let query = {
            cid: 8
          }
          wdList(1,query).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        }else if (data-1 === 7) {
          let query = {
            cid: 9
          }
          wdList(1,query).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        } else {
          let query = {
            cid: 4
          }
          wdList(1,query).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        }

      },
      getNewData(num) {
        if (this.nowColumn === 0) {
          pbInfo(num).then(res=> {
              this.articleList = res.data
              // console.log(res);
            })
        }else if (this.nowColumn === 2) {
          peList(num).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        }else {
          let query = {
            cid: 4
          }
          wdList(num,query).then(res=> {
            if(res.code === 1000){
              this.articleList = res.data
            }
          })
        }
        // pbInfo(num).then(res=> {
        //   this.articleList = res.data
        //   // console.log(res);
        // })
      },
      getData() {
        pbInfo(1).then(res=> {
          this.articleList = res.data
          // console.log(res);
        })
      }
    },
    mounted() {
      this.$store.commit('changeNum',3)
    },
    created() {
      window.scroll(0,0)
      if(this.$route.params.label){
        this.nowColumn = this.$route.params.label
      }
      if (this.nowColumn === 3) {
        peList(1).then(res=> {
          if(res.code === 1000){
            this.articleList = res.data
          }
        })
      }else if (this.nowColumn === 2){
        let query = {
          cid: 5
        }
        wdList(1,query).then(res=> {
          if(res.code === 1000){
            this.articleList = res.data
          }
        })
      }else if (this.nowColumn === 5){
        let query = {
          cid: 6
        }
        wdList(1,query).then(res=> {
          if(res.code === 1000){
            this.articleList = res.data
          }
        })
      }else if (this.nowColumn === 6){
        let query = {
          cid: 7
        }
        wdList(1,query).then(res=> {
          if(res.code === 1000){
            this.articleList = res.data
          }
        })
      } else if (this.nowColumn === 7) {
        let query = {
          cid: 8
        }
        wdList(1,query).then(res=> {
          if(res.code === 1000){
            this.articleList = res.data
          }
        })
      }else if (this.nowColumn === 8) {
        let query = {
          cid: 9
        }
        wdList(1,query).then(res=> {
          if(res.code === 1000){
            this.articleList = res.data
          }
        })
      } else {
        this.getData()
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    width: 1000px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 50px auto 0;

    .b-nav {
      width: 670px;
      height: 16px;
      display: flex;
      align-items: center;

      .location {
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        /*line-height: 16px;*/
        letter-spacing: 0;
        color: #656565;
        margin-left: 7px;
      }
      .el-breadcrumb {
        margin-left: 10px;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 16px;
        letter-spacing: 0;
        color: #656565;

        ::v-deep .is-link {
          font-weight: normal;
          color: #656565;
        }
        ::v-deep .is-link:hover {
          color: #d43e42;
          border-bottom: solid 1px #d43e42;
        }
      }

      img {
        width: 15px;
        height: 16px;
      }
    }

    .content {
      width: 1000px;
      min-height: 600px;
      margin: 30px auto 0;
      display: flex;
      justify-content: space-between;
    }
  }
</style>
